import util from '@bmp-vue/core/api/util'
const controller = 'Coiban'
export default Object.assign({}, util.GetCrud(controller, ['none']), {
})
